module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_de-54f5d664410dfb825748f6aad66d3416.png";